export default {
	"primary-highlight-color": "#ff957d",
	"secondary-highlight-color": "#ffdfd5",
	"main-color": "#184444",
	"accent-color": "#ebf3f3"
};
